import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const mastodon = defineConnector({
  identifier: "mastodon",
  name: "Mastodon",
  tagLine: "Decentralized social network",
  logo,
  protocol: "http",
  tags: ["communication"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Mastodon access token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Mastodon instance, go to **Preferences > Development** and create a new application. Copy the **access token** after saving.",
        },
      ],
    },
    {
      title: "Enter your Mastodon details",
      items: [
        {
          kind: "baseUrl",
          label: "Mastodon instance URL",
          required: true,
          placeholder: "https://mastodon.social",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Mastodon instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/api/v1/accounts/verify_credentials`,
  },
});
